import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const faqs = [
    {
      question: 'What is SocialCompass?',
      answer: 'SocialCompass is an AI-powered platform that helps you navigate your emotional world by analyzing communication patterns through email, social media, and body signals. It provides insights into your well-being, collaboration style, and emotional landscape.',
    },
    {
      question: 'What is Biolingo?',
      answer: 'Biolingo is a revolutionary tool that uses plant bio-sensors to measure plant health and connect it to human emotional well-being.',
    },
    {
      question: 'How can I try the apps?',
      answer: 'You can download the apps directly from our website or app stores. Visit the respective app pages for more information.',
    },
    {
      question: 'Who are your key clients?',
      answer: 'We have worked with leading companies such as Airbus, Ford, BMW, BASF, and many others to enhance collaboration, creativity, and customer research.',
    },
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const closeFAQ = (event, index) => {
    event.stopPropagation(); // Prevent the question box click from triggering
    if (index === activeIndex) {
      setActiveIndex(null);
    }
  };

  return (
    <section id="faq" className="faq-section">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              <span>{faq.question}</span>
              <span
                className="faq-icon"
                onClick={(event) => closeFAQ(event, index)}
                role="button"
                tabIndex={0}
              >
                {activeIndex === index ? '-' : '+'}
              </span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
